<template>
  <div class="PeakMeter">
    <div class="level" :style="{height: (currentPeak * 100) + '%'}"></div>
  </div>
</template>

<script>

import axios from 'axios'

let intervals = {
  requestAndAnimate: null,
  animate: null,
}

let PEAKS = {
  peaks: {},
  keys: [],
  animateCount: 0,
  currentPeak: 0.00,
}

export default {
  name: 'peak-meter',
  props: ['instance', 'config'],
  data() {
    return {
      peaks: {},
      keys: [],
      currentPeak: 0,
      animateCount: 0,
      intervals: {
        requestAndAnimate: null,
        animate: null,
      },
      rates: {
        requestAndAnimate: 2000,
        animate: 100,
      },
      maxAnimateSteps: 50 // Number of peaks in response.
    }
  },
  methods: {
    requestPeaks(callback){

      // console.log('requesting')

      const url = `${this.config.addresses.audioServer}`
       + `/instances/${this.instance.name}/outputs/device-1/peaks`

      axios.get(url).then((response) => {

        if (!response.data) {
          console.log('blank')
          return
        }

        // console.log(response.data)

        PEAKS.peaks = response.data

        callback()

      })

    },
    animatePeaks(){

      PEAKS.animateCount = 0
      
      PEAKS.keys = Object.keys(PEAKS.peaks)

      // console.log(this.keys)
      // console.log(this.rates.requestAndAnimate / this.rates.animate)

      clearInterval(intervals.animate)

      intervals.animate = setInterval(() => {

        PEAKS.animateCount++

        this.currentPeak = PEAKS.peaks[PEAKS.keys[PEAKS.animateCount]]

        // console.log(this.currentPeak)

        if(PEAKS.animateCount >= this.maxAnimateSteps){
          clearInterval(intervals.animate)
        }

      }, 100)

    },
    requestAndAnimatePeaks(){
      // this.requestPeaks()
      // this.animatePeaks()
      this.requestPeaks(() => {
        this.animatePeaks()
      })
    }
  },
  created() { 
    intervals.requestAndAnimate = setInterval(
      this.requestAndAnimatePeaks, this.rates.requestAndAnimate
    )
  },
  beforeDestroy() {
    clearInterval(intervals.requestAndAnimate)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>

.PeakMeter
  padding 0px
  height 40px
  width 20px
  position relative
  background rgba(0,0,0,.1)
  overflow hidden
  border-radius 3px
  box-shadow inset 0 0 3px rgba(0,0,0,.2)

  .level
    position absolute
    padding 0
    width 100%
    height 50%
    bottom 0 
    left 0
    background #555
    transition all 0.1s

</style>
